import { always } from "ramda";
import { useSelector } from "react-redux";

import { RouteValidated } from "../router/types";
import {
  getPreviousRoute,
  mapUrlToFormValidationStatusSelector,
} from "../router/utilities";

import { useCheckIsActiveItem, useNavigationHandler } from ".";

export const useGetSingleRouteDetails = (
  formValidatedSelector: RouteValidated,
  currentRoute: string,
  destinationRoute: string
): any => {
  const isDestinationRouteActive = useCheckIsActiveItem(destinationRoute);
  const isDestinationRouteValidated = useSelector(formValidatedSelector);
  const isPrevRouteValidated = useSelector(
    mapUrlToFormValidationStatusSelector[getPreviousRoute(destinationRoute)] ||
      always(false)
  );
  const onClickHandler = useNavigationHandler(
    currentRoute,
    destinationRoute,
    isDestinationRouteValidated,
    isPrevRouteValidated
  );

  return {
    isDestinationRouteActive,
    isDestinationRouteValidated,
    onClickHandler,
  };
};
